import { SprintDashboard } from '@devd-client/devd/components';
import { FC } from 'react';
import { AuthActionTypes, getUser, useAuth } from '@devd-client/devd/auth';

export const Sprint: FC = () => {
  const [appState, dispatch] = useAuth();

  return (
    <SprintDashboard
      appState={appState}
      dispatch={dispatch}
      AuthActionTypes={AuthActionTypes}
      getUser={getUser}
    />
  );
};

export default Sprint;
